/**
 * Get a nested value from an object using a dot-separated path
 * Example: getNestedValue({ user: { profile: { name: "John" } } }, "user.profile.name") => "John"
 */
export function getNestedValue(obj: unknown, path: string): unknown {
  if (!path) return obj;

  const pathParts = path.split(".");
  let current: unknown = obj;

  for (const part of pathParts) {
    if (current && typeof current === "object" && part in current) {
      current = (current as Record<string, unknown>)[part];
    } else {
      return undefined;
    }
  }

  return current;
}
